import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const en = {
  pdpaConsent:
    "I hereby expressly declare that I have read, understood, and voluntarily and unconditionally consented to the collection, use, processing, and storage of my personal data in the manner and for the purposes described in the <pdpaLink>Personal Data Processing Statement</pdpaLink>.",
  termsConsent:
    "I have read, understood, voluntarily and unconditionally agreed and accepted the <termsLink>Terms and Conditions</termsLink>.",
  "All Rights Reserved.": "All Rights Reserved.",
  "Loading...": "Loading...",
  "License Plate Recognition (LPR) Lanes Registration":
    "License Plate Recognition (LPR) Lanes Registration",
  "Registration is currently disabled for this location.": "Registration is currently disabled for this location.",
  "Welcome to the License Plate Recognition (LPR) Lanes Registration System":
    "Welcome to the License Plate Recognition (LPR) Lanes Registration System",
  "Please Select Your Registration Type": "Please Select Your Registration Type",
  Resident: "Resident",
  "Register your personal vehicle plate number.": "Register your personal vehicle plate number.",
  Company: "Company",
  "Register company vehicles and vehicles of employees under your company.":
    "Register company vehicles and vehicles of employees under your company.",
  "Registration Closed": "Registration Closed",
  "Resident registration is currently disabled.": "Resident registration is currently disabled.",
  "Company registration is currently disabled.": "Company registration is currently disabled.",
  "Please check all fields. Some required information or documents are missing.":
    "Please check all fields. Some required information or documents are missing.",
  "Enter Resident Name": "Enter Resident Name",
  "Enter TIN": "Enter TIN",
  "Select ID Type": "Select ID Type",
  "Enter ID Number": "Enter ID Number",
  "Enter Plate Number": "Enter Plate Number",
  "Enter Contact Number": "Enter Contact Number",
  "Enter Email Address": "Enter Email Address",
  "Resident Address Line 1": "Resident Address Line 1",
  "Resident Address Line 2": "Resident Address Line 2",
  "Company Address Line 1": "Company Address Line 1",
  "Company Address Line 2": "Company Address Line 2",
  "Required": "Required",
  "Not valid email address": "Not valid email address",
  "File type not allowed. Allowed types: {{allowedTypes}}":
    "File type not allowed. Allowed types: {{allowedTypes}}",
  "Configuration not loaded. Please wait...": "Configuration not loaded. Please wait...",
  "File size exceeds {{maxSize}}MB limit": "File size exceeds {{maxSize}}MB limit",
  "File type not recognized. Allowed: PDF, JPG, PNG":
    "File type not recognized. Allowed: PDF, JPG, PNG",
  "Minimum 5 characters": "Minimum 5 characters",
  "Maximum 12 characters": "Maximum 12 characters",
  "Maximum 32 characters": "Maximum 32 characters",
  "Maximum 20 characters": "Maximum 20 characters",
  Optional: "Optional",
  "Please select a vehicle pass type": "Please select a vehicle pass type",
  "Please select an option": "Please select an option",
  "You must consent to data processing": "You must consent to data processing",
  "You must accept the Terms and Conditions": "You must accept the Terms and Conditions",
  Uploaded: "Uploaded",
  Yes: "Yes",
  No: "No",
  Back: "Back",
  Submit: "Submit",
  "Add Vehicle": "Add Vehicle",
  "Add Another Vehicle": "Add Another Vehicle",
  "Remove Vehicle": "Remove Vehicle",
  "Upload": "Upload",
  "Upload a file": "Upload a file",
  "Choose File": "Choose File",
  "Class 1": "Class 1",
  "Resident Registration": "Resident Registration",
  "Company Registration": "Company Registration",
  "Resident Name": "Resident Name",
  "Tax Identification Number (TIN)": "Tax Identification Number (TIN)",
  "ID Type": "ID Type",
  "ID Number": "ID Number",
  "Contact Number": "Contact Number",
  "Email Address": "Email Address",
  "Company Registration Number": "Company Registration Number",
  "Property Owner Name": "Property Owner Name",
  "Company Name": "Company Name",
  "Contact Person": "Contact Person",
  "Vehicle Pass Type": "Vehicle Pass Type",
  "Plate Number": "Plate Number",
  "Vehicle Type": "Vehicle Type",
  "Vehicle Details": "Vehicle Details",
  "Supporting Documents": "Supporting Documents",
  "Resident Details": "Resident Details",
  "Company Details": "Company Details",
  "Vehicle Information": "Vehicle Information",
  "Vehicle Registration Document": "Vehicle Registration Document",
  "Vehicle Doc": "Vehicle Doc",
  "Proof of Residency": "Proof of Residency",
  "Sales and Purchase Agreement": "Sales and Purchase Agreement",
  "Electricity Bill": "Electricity Bill",
  "Tenancy Agreement": "Tenancy Agreement",
  "Are you a tenant?": "Are you a tenant?",
  "Upload Vehicle Document": "Upload Vehicle Document",
  "Upload Supporting Document": "Upload Supporting Document",
  "Add Plate Number": "Add Plate Number",
  "Add another vehicle": "Add another vehicle",
  "Please select a vehicle type": "Please select a vehicle type",
  "Please enter your ID Number": "Please enter your ID Number",
  "Please select a ID type": "Please select a ID type",
  "Minimum 1 character": "Minimum 1 character",
  "Minimum 1 characters": "Minimum 1 characters",
  "Maximum 16 characters": "Maximum 16 characters",
  "Maximum 48 characters": "Maximum 48 characters",
  "Maximum 64 characters": "Maximum 64 characters",
  "Minimum 5 character": "Minimum 5 character",
  "Enter Property Owner Name": "Enter Property Owner Name",
  "Enter Company Registration Number": "Enter Company Registration Number",
  "Enter Company Name": "Enter Company Name",
  "Enter Contact Person": "Enter Contact Person",
  "Plate number": "Plate number",
  "Select vehicle type": "Select vehicle type",
  "Select Vehicle Pass Type": "Select Vehicle Pass Type",
  "Resident Vehicle Information": "Resident Vehicle Information",
  "Vehicle Class": "Vehicle Class",
  "Select Vehicle Class": "Select Vehicle Class",
  "Vehicle Ownership Certificate (VOC)": "Vehicle Ownership Certificate (VOC)",
  "Tenant Details (if applicable)": "Tenant Details (if applicable)",
  "Are you registering on behalf of your Tenant?":
    "Are you registering on behalf of your Tenant?",
  "Additional Document for Tenant": "Additional Document for Tenant",
  "Terms and Conditions": "Terms and Conditions",
  "Click or drag file to upload Tenancy Agreement":
    "Click or drag file to upload Tenancy Agreement",
  "Vehicle #{{number}}": "Vehicle #{{number}}",
  "Company Electricity Bills": "Company Electricity Bills",
  "SPA/Quit Rent Bill/Assessment Bill": "SPA/Quit Rent Bill/Assessment Bill",
  "Upload SPA/Quit Rent Bill/Assessment Bill Agreement. Allowed: PDF, JPG, PNG. Max size: {{maxSize}} MB":
    "Upload SPA/Quit Rent Bill/Assessment Bill Agreement. Allowed: PDF, JPG, PNG. Max size: {{maxSize}} MB",
  "Upload Electricity Bill. Allowed: PDF, JPG, PNG. Max size: {{maxSize}} MB":
    "Upload Electricity Bill. Allowed: PDF, JPG, PNG. Max size: {{maxSize}} MB",
  "Upload Company Electricity Bill. Allowed: PDF, JPG, PNG. Max size: {{maxSize}} MB":
    "Upload Company Electricity Bill. Allowed: PDF, JPG, PNG. Max size: {{maxSize}} MB",
  "Upload Tenancy Agreement. Allowed: PDF, JPG, PNG. Max size: {{maxSize}} MB":
    "Upload Tenancy Agreement. Allowed: PDF, JPG, PNG. Max size: {{maxSize}} MB",
  "Click or drag files to upload Electricity Bill": "Click or drag files to upload Electricity Bill",
  "Click or drag file to upload SPA/Quit Rent Bill/Assessment Bill Agreement Document":
    "Click or drag file to upload SPA/Quit Rent Bill/Assessment Bill Agreement Document",
  "Click or drag company electricity bill files to this area":
    "Click or drag company electricity bill files to this area",
  "Submit Registration": "Submit Registration",
  "Processing...": "Processing...",
  "Submission Complete": "Submission Complete",
  "Submission failed": "Submission failed",
  "An unknown error occurred": "An unknown error occurred",
  "Please attach vehicle document for Vehicle #{{number}}":
    "Please attach vehicle document for Vehicle #{{number}}",
  "Please attach vehicle documents for Vehicle #{{number}} (SPA, Electric Bill, Vehicle Document)":
    "Please attach vehicle documents for Vehicle #{{number}} (SPA, Electric Bill, Vehicle Document)",
  "Please attach SPA or Tenancy Agreement document.": "Please attach SPA or Tenancy Agreement document.",
  "Please attach Electricity Bill document.": "Please attach Electricity Bill document.",
  "Please attach SSM document.": "Please attach SSM document.",
  "Please attach Company Electricity Bill.": "Please attach Company Electricity Bill.",
  "Some vehicle numbers are already registered": "Some vehicle numbers are already registered",
  "Resident {{id}} finalized successfully!": "Resident {{id}} finalized successfully!",
  "Company {{id}} finalized successfully!": "Company {{id}} finalized successfully!",
};

const ms: Record<keyof typeof en, string> = {
  pdpaConsent:
    "Saya dengan ini mengesahkan bahawa saya telah membaca, memahami, dan secara sukarela serta tanpa syarat memberikan persetujuan terhadap pengumpulan, penggunaan, pemprosesan dan penyimpanan data peribadi saya seperti yang dinyatakan dalam <pdpaLink>Penyata Pemprosesan Data Peribadi</pdpaLink>.",
  termsConsent:
    "Saya telah membaca, memahami, secara sukarela dan tanpa syarat bersetuju serta menerima <termsLink>Terma dan Syarat</termsLink>.",
  "All Rights Reserved.": "Hak Cipta Terpelihara.",
  "Loading...": "Sedang memuatkan...",
  "License Plate Recognition (LPR) Lanes Registration":
    "Pendaftaran Lorong Pengecaman Nombor Plat (LPR)",
  "Registration is currently disabled for this location.":
    "Pendaftaran buat masa ini tidak dibuka untuk lokasi ini.",
  "Welcome to the License Plate Recognition (LPR) Lanes Registration System":
    "Selamat datang ke Sistem Pendaftaran Lorong Pengecaman Nombor Plat (LPR)",
  "Please Select Your Registration Type": "Sila Pilih Jenis Pendaftaran Anda",
  Resident: "Penduduk",
  "Register your personal vehicle plate number.": "Daftarkan nombor plat kenderaan peribadi anda.",
  Company: "Syarikat",
  "Register company vehicles and vehicles of employees under your company.":
    "Daftarkan kenderaan syarikat dan kenderaan pekerja di bawah syarikat anda.",
  "Registration Closed": "Pendaftaran Ditutup",
  "Resident registration is currently disabled.": "Pendaftaran penduduk buat masa ini tidak dibuka.",
  "Company registration is currently disabled.": "Pendaftaran syarikat buat masa ini tidak dibuka.",
  "Please check all fields. Some required information or documents are missing.":
    "Sila semak semua medan. Maklumat atau dokumen yang diperlukan masih belum lengkap.",
  "Enter Resident Name": "Masukkan Nama Penduduk",
  "Enter TIN": "Masukkan Nombor Pengenalan Cukai (TIN)",
  "Select ID Type": "Pilih Jenis ID",
  "Enter ID Number": "Masukkan Nombor ID",
  "Enter Plate Number": "Masukkan Nombor Plat",
  "Enter Contact Number": "Masukkan Nombor Telefon",
  "Enter Email Address": "Masukkan Alamat E-mel",
  "Resident Address Line 1": "Alamat Penduduk Baris 1",
  "Resident Address Line 2": "Alamat Penduduk Baris 2",
  "Company Address Line 1": "Alamat Syarikat Baris 1",
  "Company Address Line 2": "Alamat Syarikat Baris 2",
  Required: "Wajib diisi",
  "Not valid email address": "Alamat e-mel tidak sah",
  "File type not allowed. Allowed types: {{allowedTypes}}":
    "Jenis fail tidak dibenarkan. Jenis yang dibenarkan: {{allowedTypes}}",
  "Configuration not loaded. Please wait...": "Konfigurasi belum dimuatkan. Sila tunggu...",
  "File size exceeds {{maxSize}}MB limit": "Saiz fail melebihi had {{maxSize}}MB",
  "File type not recognized. Allowed: PDF, JPG, PNG":
    "Jenis fail tidak dikenali. Format yang dibenarkan: PDF, JPG, PNG",
  "Minimum 5 characters": "Minimum 5 aksara",
  "Maximum 12 characters": "Maksimum 12 aksara",
  "Maximum 32 characters": "Maksimum 32 aksara",
  "Maximum 20 characters": "Maksimum 20 aksara",
  Optional: "Pilihan",
  "Please select a vehicle pass type": "Sila pilih jenis pas kenderaan",
  "Please select an option": "Sila pilih satu pilihan",
  "You must consent to data processing": "Anda mesti bersetuju dengan pemprosesan data",
  "You must accept the Terms and Conditions": "Anda mesti menerima Terma dan Syarat",
  Uploaded: "Dimuat naik",
  Yes: "Ya",
  No: "Tidak",
  Back: "Kembali",
  Submit: "Hantar",
  "Add Vehicle": "Tambah Kenderaan",
  "Add Another Vehicle": "Tambah Kenderaan Lain",
  "Remove Vehicle": "Buang Kenderaan",
  Upload: "Muat naik",
  "Upload a file": "Muat naik fail",
  "Choose File": "Pilih Fail",
  "Class 1": "Kelas 1",
  "Resident Registration": "Pendaftaran Penduduk",
  "Company Registration": "Pendaftaran Syarikat",
  "Resident Name": "Nama Penduduk",
  "Tax Identification Number (TIN)": "Nombor Pengenalan Cukai (TIN)",
  "ID Type": "Jenis ID",
  "ID Number": "Nombor ID",
  "Contact Number": "Nombor Telefon",
  "Email Address": "Alamat E-mel",
  "Company Registration Number": "Nombor Pendaftaran Syarikat",
  "Property Owner Name": "Nama Pemilik Hartanah",
  "Company Name": "Nama Syarikat",
  "Contact Person": "Orang Untuk Dihubungi",
  "Vehicle Pass Type": "Jenis Pas Kenderaan",
  "Plate Number": "Nombor Plat",
  "Vehicle Type": "Jenis Kenderaan",
  "Vehicle Details": "Maklumat Kenderaan",
  "Supporting Documents": "Dokumen Sokongan",
  "Resident Details": "Maklumat Penduduk",
  "Company Details": "Maklumat Syarikat",
  "Vehicle Information": "Maklumat Kenderaan",
  "Vehicle Registration Document": "Dokumen Pendaftaran Kenderaan",
  "Vehicle Doc": "Dokumen Kenderaan",
  "Proof of Residency": "Bukti Kediaman",
  "Sales and Purchase Agreement": "Perjanjian Jual Beli",
  "Electricity Bill": "Bil Elektrik",
  "Tenancy Agreement": "Perjanjian Sewaan",
  "Are you a tenant?": "Adakah anda penyewa?",
  "Upload Vehicle Document": "Muat Naik Dokumen Kenderaan",
  "Upload Supporting Document": "Muat Naik Dokumen Sokongan",
  "Add Plate Number": "Tambah Nombor Plat",
  "Add another vehicle": "Tambah kenderaan lain",
  "Please select a vehicle type": "Sila pilih jenis kenderaan",
  "Please enter your ID Number": "Sila masukkan nombor ID anda",
  "Please select a ID type": "Sila pilih jenis ID",
  "Minimum 1 character": "Minimum 1 aksara",
  "Minimum 1 characters": "Minimum 1 aksara",
  "Maximum 16 characters": "Maksimum 16 aksara",
  "Maximum 48 characters": "Maksimum 48 aksara",
  "Maximum 64 characters": "Maksimum 64 aksara",
  "Minimum 5 character": "Minimum 5 aksara",
  "Enter Property Owner Name": "Masukkan Nama Pemilik Hartanah",
  "Enter Company Registration Number": "Masukkan Nombor Pendaftaran Syarikat",
  "Enter Company Name": "Masukkan Nama Syarikat",
  "Enter Contact Person": "Masukkan Nama Orang Untuk Dihubungi",
  "Plate number": "Nombor plat",
  "Select vehicle type": "Pilih jenis kenderaan",
  "Select Vehicle Pass Type": "Pilih Jenis Pas Kenderaan",
  "Resident Vehicle Information": "Maklumat Kenderaan Penduduk",
  "Vehicle Class": "Kelas Kenderaan",
  "Select Vehicle Class": "Pilih Kelas Kenderaan",
  "Vehicle Ownership Certificate (VOC)": "Sijil Pemilikan Kenderaan (VOC)",
  "Tenant Details (if applicable)": "Maklumat Penyewa (jika berkenaan)",
  "Are you registering on behalf of your Tenant?":
    "Adakah anda mendaftar bagi pihak penyewa anda?",
  "Additional Document for Tenant": "Dokumen Tambahan untuk Penyewa",
  "Terms and Conditions": "Terma dan Syarat",
  "Click or drag file to upload Tenancy Agreement":
    "Klik atau seret fail untuk memuat naik Perjanjian Sewaan",
  "Vehicle #{{number}}": "Kenderaan #{{number}}",
  "Company Electricity Bills": "Bil Elektrik Syarikat",
  "SPA/Quit Rent Bill/Assessment Bill": "Perjanjian Jual Beli/Bil Cukai Tanah/Bil Taksiran",
  "Upload SPA/Quit Rent Bill/Assessment Bill Agreement. Allowed: PDF, JPG, PNG. Max size: {{maxSize}} MB":
    "Muat naik Perjanjian Jual Beli/Bil Cukai Tanah/Bil Taksiran. Format dibenarkan: PDF, JPG, PNG. Saiz maksimum: {{maxSize}} MB",
  "Upload Electricity Bill. Allowed: PDF, JPG, PNG. Max size: {{maxSize}} MB":
    "Muat naik Bil Elektrik. Format dibenarkan: PDF, JPG, PNG. Saiz maksimum: {{maxSize}} MB",
  "Upload Company Electricity Bill. Allowed: PDF, JPG, PNG. Max size: {{maxSize}} MB":
    "Muat naik Bil Elektrik Syarikat. Format dibenarkan: PDF, JPG, PNG. Saiz maksimum: {{maxSize}} MB",
  "Upload Tenancy Agreement. Allowed: PDF, JPG, PNG. Max size: {{maxSize}} MB":
    "Muat naik Perjanjian Sewaan. Format dibenarkan: PDF, JPG, PNG. Saiz maksimum: {{maxSize}} MB",
  "Click or drag files to upload Electricity Bill":
    "Klik atau seret fail untuk memuat naik Bil Elektrik",
  "Click or drag file to upload SPA/Quit Rent Bill/Assessment Bill Agreement Document":
    "Klik atau seret fail untuk memuat naik Dokumen Perjanjian Jual Beli/Bil Cukai Tanah/Bil Taksiran",
  "Click or drag company electricity bill files to this area":
    "Klik atau seret fail bil elektrik syarikat ke kawasan ini",
  "Submit Registration": "Hantar Pendaftaran",
  "Processing...": "Sedang diproses...",
  "Submission Complete": "Pendaftaran Selesai",
  "Submission failed": "Pendaftaran gagal",
  "An unknown error occurred": "Ralat yang tidak diketahui telah berlaku",
  "Please attach vehicle document for Vehicle #{{number}}":
    "Sila lampirkan dokumen kenderaan untuk Kenderaan #{{number}}",
  "Please attach vehicle documents for Vehicle #{{number}} (SPA, Electric Bill, Vehicle Document)":
    "Sila lampirkan dokumen kenderaan untuk Kenderaan #{{number}} (SPA, Bil Elektrik dan Dokumen Kenderaan)",
  "Please attach SPA or Tenancy Agreement document.":
    "Sila lampirkan dokumen SPA atau Perjanjian Sewaan.",
  "Please attach Electricity Bill document.": "Sila lampirkan dokumen Bil Elektrik.",
  "Please attach SSM document.": "Sila lampirkan dokumen SSM.",
  "Please attach Company Electricity Bill.": "Sila lampirkan Bil Elektrik Syarikat.",
  "Some vehicle numbers are already registered": "Sesetengah nombor kenderaan telah didaftarkan.",
  "Resident {{id}} finalized successfully!": "Pendaftaran penduduk {{id}} berjaya diselesaikan!",
  "Company {{id}} finalized successfully!": "Pendaftaran syarikat {{id}} berjaya diselesaikan!",
};

const zhCN: Record<keyof typeof en, string> = {
  pdpaConsent:
    "本人特此声明，本人已阅读、理解并自愿且无条件地同意按照《<pdpaLink>个人数据处理声明</pdpaLink>》中所述的方式和目的收集、使用、处理和存储本人的个人数据。",
  termsConsent:
    "本人已阅读、理解、自愿且无条件地同意并接受《<termsLink>所有条规</termsLink>》。",
  "All Rights Reserved.": "版权所有。",
  "Loading...": "加载中...",
  "License Plate Recognition (LPR) Lanes Registration": "车牌识别（LPR）车道注册",
  "Registration is currently disabled for this location.": "此地点目前暂停注册。",
  "Welcome to the License Plate Recognition (LPR) Lanes Registration System":
    "欢迎使用车牌识别（LPR）车道注册系统",
  "Please Select Your Registration Type": "请选择注册类型",
  Resident: "居民",
  "Register your personal vehicle plate number.": "登记您的个人车辆车牌号码。",
  Company: "公司",
  "Register company vehicles and vehicles of employees under your company.":
    "登记公司车辆及公司员工的车辆。",
  "Registration Closed": "注册已关闭",
  "Resident registration is currently disabled.": "居民注册目前已暂停。",
  "Company registration is currently disabled.": "公司注册目前已暂停。",
  "Please check all fields. Some required information or documents are missing.":
    "请检查所有字段。部分必填信息或文件尚未提供。",
  "Enter Resident Name": "请输入居民姓名",
  "Enter TIN": "请输入纳税识别号码（TIN）",
  "Select ID Type": "请选择证件类型",
  "Enter ID Number": "请输入证件号码",
  "Enter Plate Number": "请输入车牌号码",
  "Enter Contact Number": "请输入联系电话",
  "Enter Email Address": "请输入电子邮箱地址",
  "Resident Address Line 1": "居民地址第一行",
  "Resident Address Line 2": "居民地址第二行",
  "Company Address Line 1": "公司地址第一行",
  "Company Address Line 2": "公司地址第二行",
  Required: "必填",
  "Not valid email address": "电子邮箱地址无效",
  "File type not allowed. Allowed types: {{allowedTypes}}":
    "不支持此文件类型。允许的文件类型：{{allowedTypes}}",
  "Configuration not loaded. Please wait...": "配置尚未加载，请稍候...",
  "File size exceeds {{maxSize}}MB limit": "文件大小超过 {{maxSize}}MB 限制",
  "File type not recognized. Allowed: PDF, JPG, PNG":
    "无法识别文件类型。允许格式：PDF、JPG、PNG",
  "Minimum 5 characters": "至少 5 个字符",
  "Maximum 12 characters": "最多 12 个字符",
  "Maximum 32 characters": "最多 32 个字符",
  "Maximum 20 characters": "最多 20 个字符",
  Optional: "可选",
  "Please select a vehicle pass type": "请选择车辆通行证类型",
  "Please select an option": "请选择一个选项",
  "You must consent to data processing": "您必须同意数据处理",
  "You must accept the Terms and Conditions": "您必须接受条款与条件",
  Uploaded: "已上传",
  Yes: "是",
  No: "不是",
  Back: "返回",
  Submit: "提交",
  "Add Vehicle": "添加车辆",
  "Add Another Vehicle": "添加另一辆车",
  "Remove Vehicle": "移除车辆",
  Upload: "上传",
  "Upload a file": "上传文件",
  "Choose File": "选择文件",
  "Class 1": "类别 1",
  "Resident Registration": "居民注册",
  "Company Registration": "公司注册",
  "Resident Name": "居民姓名",
  "Tax Identification Number (TIN)": "纳税识别号码（TIN）",
  "ID Type": "证件类型",
  "ID Number": "证件号码",
  "Contact Number": "联系电话",
  "Email Address": "电子邮箱地址",
  "Company Registration Number": "公司注册号码",
  "Property Owner Name": "业主姓名",
  "Company Name": "公司名称",
  "Contact Person": "联系人",
  "Vehicle Pass Type": "车辆通行证类型",
  "Plate Number": "车牌号码",
  "Vehicle Type": "车辆类型",
  "Vehicle Details": "车辆资料",
  "Supporting Documents": "证明文件",
  "Resident Details": "居民资料",
  "Company Details": "公司资料",
  "Vehicle Information": "车辆资料",
  "Vehicle Registration Document": "车辆注册文件",
  "Vehicle Doc": "车辆文件",
  "Proof of Residency": "居住证明",
  "Sales and Purchase Agreement": "买卖协议",
  "Electricity Bill": "电费单",
  "Tenancy Agreement": "租赁协议",
  "Are you a tenant?": "您是租户吗？",
  "Upload Vehicle Document": "上传车辆文件",
  "Upload Supporting Document": "上传证明文件",
  "Add Plate Number": "添加车牌号码",
  "Add another vehicle": "添加另一辆车",
  "Please select a vehicle type": "请选择车辆类型",
  "Please enter your ID Number": "请输入您的证件号码",
  "Please select a ID type": "请选择证件类型",
  "Minimum 1 character": "至少 1 个字符",
  "Minimum 1 characters": "至少 1 个字符",
  "Maximum 16 characters": "最多 16 个字符",
  "Maximum 48 characters": "最多 48 个字符",
  "Maximum 64 characters": "最多 64 个字符",
  "Minimum 5 character": "至少 5 个字符",
  "Enter Property Owner Name": "请输入业主姓名",
  "Enter Company Registration Number": "请输入公司注册号码",
  "Enter Company Name": "请输入公司名称",
  "Enter Contact Person": "请输入联系人姓名",
  "Plate number": "车牌号码",
  "Select vehicle type": "请选择车辆类型",
  "Select Vehicle Pass Type": "请选择车辆通行证类型",
  "Resident Vehicle Information": "居民车辆信息",
  "Vehicle Class": "车辆类别",
  "Select Vehicle Class": "请选择车辆类别",
  "Vehicle Ownership Certificate (VOC)": "车辆所有权证书（VOC）",
  "Tenant Details (if applicable)": "租户资料（如适用）",
  "Are you registering on behalf of your Tenant?": "您是否代表租户办理注册？",
  "Additional Document for Tenant": "租户补充文件",
  "Terms and Conditions": "条款与条件",
  "Click or drag file to upload Tenancy Agreement": "点击或拖动文件以上传租赁协议",
  "Vehicle #{{number}}": "车辆 #{{number}}",
  "Company Electricity Bills": "公司电费单",
  "SPA/Quit Rent Bill/Assessment Bill": "买卖协议/地税单/评估税单",
  "Upload SPA/Quit Rent Bill/Assessment Bill Agreement. Allowed: PDF, JPG, PNG. Max size: {{maxSize}} MB":
    "请上传买卖协议/地税单/评估税单。允许格式：PDF、JPG、PNG。最大文件：{{maxSize}} MB",
  "Upload Electricity Bill. Allowed: PDF, JPG, PNG. Max size: {{maxSize}} MB":
    "请上传电费单。允许格式：PDF、JPG、PNG。最大文件：{{maxSize}} MB",
  "Upload Company Electricity Bill. Allowed: PDF, JPG, PNG. Max size: {{maxSize}} MB":
    "请上传公司电费单。允许格式：PDF、JPG、PNG。最大文件：{{maxSize}} MB",
  "Upload Tenancy Agreement. Allowed: PDF, JPG, PNG. Max size: {{maxSize}} MB":
    "请上传租赁协议。允许格式：PDF、JPG、PNG。最大文件：{{maxSize}} MB",
  "Click or drag files to upload Electricity Bill": "点击或拖动文件以上传电费单",
  "Click or drag file to upload SPA/Quit Rent Bill/Assessment Bill Agreement Document":
    "点击或拖动文件以上传买卖协议/地税单/评估税单",
  "Click or drag company electricity bill files to this area":
    "点击或拖动公司电费单文件至此区域",
  "Submit Registration": "提交注册",
  "Processing...": "处理中...",
  "Submission Complete": "提交成功",
  "Submission failed": "提交失败",
  "An unknown error occurred": "发生未知错误",
  "Please attach vehicle document for Vehicle #{{number}}":
    "请附上车辆 #{{number}} 的车辆文件",
  "Please attach vehicle documents for Vehicle #{{number}} (SPA, Electric Bill, Vehicle Document)":
    "请附上车辆 #{{number}} 的车辆文件（买卖协议、电费单和车辆文件）",
  "Please attach SPA or Tenancy Agreement document.": "请附上买卖协议或租赁协议文件。",
  "Please attach Electricity Bill document.": "请附上电费单文件。",
  "Please attach SSM document.": "请附上SSM文件。",
  "Please attach Company Electricity Bill.": "请附上公司电费单。",
  "Some vehicle numbers are already registered": "部分车辆号码已注册。",
  "Resident {{id}} finalized successfully!": "居民 {{id}} 注册成功！",
  "Company {{id}} finalized successfully!": "公司 {{id}} 注册成功！",
};

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ms: { translation: ms },
    "zh-CN": { translation: zhCN },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  returnNull: false,
});

export type AppLanguage = "en" | "ms" | "zh-CN";

export function normalizeLanguage(value: string | null | undefined): AppLanguage | undefined {
  switch (value?.toLowerCase()) {
    case "en":
      return "en";
    case "ms":
    case "my":
      return "ms";
    case "cn":
    case "zh":
    case "zh-cn":
      return "zh-CN";
    default:
      return undefined;
  }
}

export default i18n;
